import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, RedirectionData } from '../../types.tsx';

export const setRedirectionData =
	(redirectionData: RedirectionData) =>
	({ setState, getState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			redirectionData,
		});
	};

export const resetRedirectionData =
	() =>
	({ setState, getState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			redirectionData: {
				onPublishRedirectUrl: '',
				onCloseRedirectUrl: '',
			},
		});
	};
